import { createFileRoute } from '@tanstack/react-router'

import { ConnectionTab } from '@/components/zalo/connection-tab'

export const Route = createFileRoute('/_app/_authed/_sidebar/settings/zalo/')({
    component: ConnectionTab,
})
